import { Component, OnInit } from '@angular/core';
import { Cards, Players, PokerService, RealPlayers } from '../../poker.service';

@Component({
  selector: 'app-poker-desk',
  templateUrl: './poker-desk.component.html',
  styleUrls: ['./poker-desk.component.css']
})
export class PokerDeskComponent implements OnInit {
  /** 上 */
  playerSlot1:Players;
  /** 右 */
  playerSlot2:Players;
  /** 下 */
  playerSlot3:Players;
  /** 左 */
  playerSlot4:Players;

  started = false;
  gameMode = 'PG';
  constructor(private poke:PokerService) { }

  ngOnInit(): void {
  }
  get gameOver(){
    return this.poke.gameOver;
  }
  get gameOverMsg(){
    return (this.poke.playerWin?`You Win`:'You Lose')+` in ${this.poke.round} rounds`;
  }
  get msg(){
    return this.poke.msg;
  }
  async start(){
    if(this.gameMode=='PG'){
      await this.poke.startPickGhost();
    }else if(this.gameMode =='99'){
      await this.poke.start99();
    }
    this.playerSlot1 = this.poke.players.find(x=>x.seat == 1)
    this.playerSlot2 = this.poke.players.find(x=>x.seat == 2)
    this.playerSlot3 = this.poke.players.find(x=>x.seat == 3)//玩家
    this.playerSlot4 = this.poke.players.find(x=>x.seat == 4)
    //this.desk = []
    this.started = true;
  }

  
  show:boolean = false;
  open(){
    this.show = true;
  }
  close(){
    this.show = false;
  }
}
